var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 0.00195312C14.8038 0.00195312 0 14.8052 0 33.0001C0 51.1955 14.8038 65.9986 33 65.9986C51.1962 65.9986 66 51.1955 66 33.0001C66 14.8052 51.1962 0.00195312 33 0.00195312ZM33 59.9988C18.1122 59.9988 6 47.8874 6 33.0004C6 18.1134 18.1122 6.00195 33 6.00195C47.8878 6.00195 60 18.1134 60 33.0001C60 47.8876 47.8878 59.9988 33 59.9988Z",
    fill: "#08E7F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26.001C31.3432 26.001 30 27.3442 30 29.001V48.9976C30 50.6544 31.3432 51.9976 33 51.9976C34.6568 51.9976 36 50.6544 36 48.9976V29.001C36 27.3444 34.6568 26.001 33 26.001Z",
    fill: "#08E7F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14.002C32.21 14.002 31.4378 14.322 30.878 14.88C30.32 15.438 30 16.212 30 17.002C30 17.792 30.32 18.564 30.878 19.124C31.436 19.682 32.21 20.002 33 20.002C33.79 20.002 34.562 19.682 35.1218 19.124C35.6798 18.564 36 17.792 36 17.002C36 16.212 35.6798 15.438 35.1218 14.88C34.562 14.3218 33.79 14.002 33 14.002Z",
    fill: "#08E7F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.2d64b90a07cc0e1fc3c0302094d4dd60.svg";
export { ForwardRef as ReactComponent };